import script from "./org.vue?vue&type=script&setup=true&lang=js"
export * from "./org.vue?vue&type=script&setup=true&lang=js"

import "./org.vue?vue&type=style&index=0&id=3a471ed3&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a471ed3"]])

export default __exports__